<template>
  <div class="page-container">
    <div class="mc-list-header">
      <McInlineFilter
        :filterItems="inlineFilterItems"
        :activeKeys="activeFilters['status.name']"
        @update:activeKeys="handleChangeActiveFilters([{ key: 'status.name', values: $event }])"
      />

      <McTable
        v-show="isTableDataAvailable"
        :fields="fields"
        :apiClient="apiClient"
        :activeFilters="activeFilters"
        :customHandlers="customHandlers"
        :hasCheckbox="false"
        :hasSelectAll="false"
        withCard
        searchable
        @available-change="handleDataAvailable"
        stickyHeader
      >
        <template #cell(status.name)="{ value, item }">
          <span
            v-if="item.status?.color"
            class="__status-dots"
            :style="{ backgroundColor: item.status.color }"
          ></span>
          <span style="color: #344264">{{ value }}</span>
        </template>

        <template #cell(version.addendum)="{ value }">
          <div>{{ value == 0 ? '-' : 'v.' + value }}</div>
        </template>

        <template #cell(vendor.name)="{ value, item }">
          <router-link :to="{ name: 'Master Vendor Detail', params: { id: item.vendor.id } }">
            <span class="__link"> {{ value }} </span>
          </router-link>
        </template>

        <template #cell(effective_date)="{ value }">
          <div>{{ formatIndexDate(value, 'DD MMMM YYYY').date }}</div>
        </template>

        <template #cell(expired_date)="{ value }">
          <div>{{ formatIndexDate(value, 'DD MMMM YYYY').date }}</div>
        </template>

        <template #cell()="{ value }">
          <div>{{ value == '' || value == null ? '-' : value }}</div>
        </template>
      </McTable>

      <b-card v-show="!isTableDataAvailable">
        <div class="empty-table-container">
          <img src="@/assets/images/no-data-illustration.png" alt />
          <strong>Belum ada data kontrak vendor</strong>
          <p>Tambahkan data terlebih dulu ya!</p>
          <McButton
            variant="primary"
            :text="$t('global.addField')"
            icon="icon-outline_plus"
            @click="handleAdd"
          />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import McTable from '@/components/McTable'
import McButton from '@/components/McButton'
import McInlineFilter from '@/components/McInlineFilter'

import { formatIndexDate } from '@/helpers/tzDate'
import transformFilter from '@/helpers/resourceful/transform-filter'

import * as Contract from '@/services/rest-api/lib/contract/contract'

import listTableFields from './lib/fields/list-table-fields.js'
import inlineFilterItems from './lib/constants/inline-filter-items.js'
import filterMappings from './lib/constants/filter-mappings.js'

/**
 * Starter component
 */
export default {
  components: {
    McTable,
    McButton,
    McInlineFilter,
  },
  data() {
    return {
      isTableDataAvailable: true,
      inlineFilterItems,
      activeFilters: {},
    }
  },
  computed: {
    title() {
      return this.$t('master.vendorContract.title')
    },
    subTitle() {
      return this.$t('master.vendorContract.list')
    },
    apiClient() {
      let getContract = Contract.get
      if (Object.keys(this.activeFilters).length > 0) {
        let filters = transformFilter(filterMappings, this.activeFilters)
        getContract = Contract.getWithFilters(filters)
      }

      return {
        get: getContract,
      }
    },
    fields() {
      return listTableFields
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
        handleAdd: this.handleAdd,
      }
    },
  },
  methods: {
    formatIndexDate,

    /**
     * @typedef {Object} Filter
     * @property {String} key
     * @property {String} values
     *
     * @param {Filter[]} filters
     */
    handleChangeActiveFilters(filters) {
      this.isTableDataAvailable = true
      for (const filter of filters) {
        this.$delete(this.activeFilters, filter.key)

        if (filter.values == null) continue
        if (Array.isArray(filter.values) && filter.values.length === 0) continue

        this.$set(this.activeFilters, filter.key, filter.values)
      }
    },
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleClickRow(item) {
      this.$router.push({
        name: 'Master Vendor Contract Detail',
        params: { vendorId: item.vendor.id, contractId: item.id, versionId: item.version.id },
      })
    },
    handleAdd() {
      this.$router.push({ name: 'Master Vendor Contract Create' })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  .mc-list-header {
    margin-bottom: 24px;
  }

  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .__link {
    color: $blue-400;
    font-weight: 600;
  }
}
</style>
